import React from 'react'
import {
  Box,
  Checkbox,
  Flex,
  InputGroup,
  Text,
  Link,
  Button,
} from '@clear/design-system'
import { Form, StepSubTitle, StepTitle } from '@components/layout/Form'
import PageContent from '@components/layout/PageContent'
import VerificationCodeForm from '@components/VerificationCodeForm'
import { FormSteps } from '@pages/auth'

const V1AuthFlow = ({
  step,
  verificationFormData,
  onVerificationSubmit,
  otpFailureMessage,
  setOtpFailureMessage,
  isLoading,
  handleSubmit,
  onSubmitContact,
  register,
  errors,
  isValid,
}) => {
  return (
    <PageContent>
      <Box marginLeft="auto" marginRight="auto" width={['95%', '572px']}>
        <StepTitle textAlign="center">
          TSA PreCheck<sup>®</sup> through CLEAR
        </StepTitle>
        <StepSubTitle textAlign="center" mb={5} fontSize={3}>
          Apply or renew in minutes to enjoy smoother security for five years.
        </StepSubTitle>
      </Box>
      <Box
        width={['95%', '572px']}
        marginLeft="auto"
        marginRight="auto"
        border="1px solid #CCCED1"
        borderRadius="8px"
        paddingX={['20px', '50px']}
        paddingY={['20px', '40px']}
        backgroundColor="neutralsWhite"
      >
        {step === FormSteps.VERIFICATION && (
          <VerificationCodeForm
            showLogo={true}
            onSubmitCode={onVerificationSubmit}
            otpFailureMessage={otpFailureMessage}
            setOtpFailureMessage={setOtpFailureMessage}
            isLoading={isLoading}
            onResendCode={onSubmitContact}
            contactInfo={verificationFormData}
          />
        )}
        {step === FormSteps.CONTACT && (
          <>
            <img
              className="pb-5 mx-auto"
              src="tsa-pre-logo-auth.svg"
              alt="TSA pre-check with CLEAR logo"
            />

            <StepSubTitle textAlign="center" fontSize={3}>
              Enter your email and mobile number. You'll be sent a one-time code
              to sign in / create an account
            </StepSubTitle>

            <Form onSubmit={handleSubmit(onSubmitContact)}>
              <InputGroup
                data-cy="email"
                placeholder={'Email'}
                {...register('emailAddress')}
                error={errors.email?.message}
                mb={2}
                containerProps={{ padding: 0 }}
              />

              <Flex flexDirection="row">
                <InputGroup
                  data-cy={'countryCode'}
                  name="countryCode"
                  disabled
                  value="+1"
                  containerProps={{
                    padding: 0,
                    width: '20%',
                  }}
                />

                <InputGroup
                  data-cy="phoneNumber"
                  placeholder={'Cell Phone Number'}
                  {...register('phoneNumber')}
                  error={errors.phoneNumber?.message}
                  containerProps={{
                    padding: 0,
                    marginLeft: '10px',
                    width: '90%',
                  }}
                />
              </Flex>

              <Checkbox
                text={
                  <Text
                    as="p"
                    color="neutralsTextGray"
                    variant="body"
                    fontSize="12px"
                  >
                    By providing my telephone number and checking this box, I
                    agree to the{' '}
                    <Link
                      target="blank"
                      variant="regular"
                      color="brandDarkBlue"
                      href="/terms"
                    >
                      Terms & Conditions
                    </Link>{' '}
                    and I consent to receive multifactor text messages related
                    to my TSA&nbsp;PreCheck® account.
                  </Text>
                }
                data-cy="acceptTerms"
                {...register('acceptTerms')}
                containerProps={{
                  padding: 0,
                  marginY: 20,
                }}
              />

              <Button
                data-cy="sendLoginCode"
                type="submit"
                text="Send Login Code"
                disabled={
                  Boolean(Object.keys(errors).length) || !isValid || isLoading
                }
                height="3rem !important"
              />
            </Form>
          </>
        )}
      </Box>
    </PageContent>
  )
}

export default V1AuthFlow
